import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import type { KyrgyzstanAmenitiesRouteState } from 'entities/kyrgyzstan/lib'
import { KyrgyzstanEmpty } from 'entities/kyrgyzstan/ui'

import { HeaderGoBack } from 'shared/ui/header-go-back'

import { AmenitiesList } from './ui/amenities-list'

import s from './styles.module.scss'

const KyrgyzstanAllAmenitiesPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const { state } = useLocation()

  const amenities = (state as KyrgyzstanAmenitiesRouteState | null)?.amenities
  const data = amenities?.realtyId === id ? amenities : null

  const handleGoBack = () => {
    navigate(-1)
  }

  const header = (
    <HeaderGoBack
      title={t('kyrgyzstan_block.detail.all_amenities_title')}
      onGoBack={handleGoBack}
      variant="grey"
      buttonWhite
    />
  )

  if (!data) {
    return (
      <div className={s.container}>
        {header}
        <KyrgyzstanEmpty title={t('kyrgyzstan_block.error.title')} />
      </div>
    )
  }

  const { dynamicFields } = data

  if (!dynamicFields.items || dynamicFields.items.length === 0) {
    return (
      <div className={s.container}>
        {header}
        <KyrgyzstanEmpty title={t('kyrgyzstan_block.error.title')} />
      </div>
    )
  }

  return (
    <div className={s.container}>
      {header}
      <div className={s.content}>
        <AmenitiesList dynamicFields={dynamicFields} />
      </div>
    </div>
  )
}

export default KyrgyzstanAllAmenitiesPage
